import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './auth.js';
import { BRAND } from './branding.js';
import { Login } from './pages/Login.js';
import { ForgotPassword } from './pages/ForgotPassword.js';
import { ResetPassword } from './pages/ResetPassword.js';
import { AdminLayout } from './pages/AdminLayout.js';
import { ProductsList } from './pages/ProductsList.js';
import { ProductEdit } from './pages/ProductEdit.js';
import { FlowsList } from './pages/FlowsList.js';
import { FlowEdit } from './pages/FlowEdit.js';
import { ProfileEdit } from './pages/ProfileEdit.js';
import { SubscriptionPlans } from './pages/SubscriptionPlans.js';
import { SubscriptionPlanEdit } from './pages/SubscriptionPlanEdit.js';
import { SubscriptionsList } from './pages/SubscriptionsList.js';
import { SubscriptionDetailPage } from './pages/SubscriptionDetail.js';
import { UsersList } from './pages/UsersList.js';
import { UserEdit } from './pages/UserEdit.js';
import { Standalone } from './pages/Standalone.js';
import { SubscriptionCancel } from './pages/SubscriptionCancel.js';
import { Dashboard } from './pages/Dashboard.js';
import { PaymentsList } from './pages/PaymentsList.js';
import { AuditLog } from './pages/AuditLog.js';
import { PromoCodesList } from './pages/PromoCodesList.js';
import { PromoCodeEdit } from './pages/PromoCodeEdit.js';
import { CompTicketsList } from './pages/CompTicketsList.js';
import { CompTicketIssue } from './pages/CompTicketIssue.js';
import { PaymentSuccess, PaymentFail } from './pages/PaymentResult.js';
import { CheckIn } from './pages/CheckIn.js';
import './index.css';
import { TicketPreviewPage } from './pages/TicketPreviewPage.js';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          {/* На установке «только Google» паролей нет — восстанавливать нечего. */}
          <Route
            path="/forgot-password"
            element={BRAND.passwordLogin ? <ForgotPassword /> : <Navigate to="/login" replace />}
          />
          <Route
            path="/reset-password"
            element={BRAND.passwordLogin ? <ResetPassword /> : <Navigate to="/login" replace />}
          />
          <Route path="/p/:slug" element={<Standalone />} />
          <Route path="/subscription/cancel" element={<SubscriptionCancel />} />
          <Route path="/paid" element={<PaymentSuccess />} />
          <Route path="/fail" element={<PaymentFail />} />
          <Route path="/checkin" element={<CheckIn />} />
          {/* Предпросмотр билета — отдельная вкладка без меню админки. */}
          <Route path="/admin/ticket-preview" element={<TicketPreviewPage />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Navigate to="products" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="products" element={<ProductsList />} />
            <Route path="products/new" element={<ProductEdit />} />
            <Route path="products/:id" element={<ProductEdit />} />
            <Route path="flows" element={<FlowsList />} />
            <Route path="flows/new" element={<FlowEdit />} />
            <Route path="flows/:id" element={<FlowEdit />} />
            <Route path="payments" element={<PaymentsList />} />
            <Route path="promo-codes" element={<PromoCodesList />} />
            <Route path="promo-codes/new" element={<PromoCodeEdit />} />
            <Route path="promo-codes/:id" element={<PromoCodeEdit />} />
            <Route path="comp-tickets" element={<CompTicketsList />} />
            <Route path="comp-tickets/new" element={<CompTicketIssue />} />
            <Route path="plans" element={<SubscriptionPlans />} />
            <Route path="plans/new" element={<SubscriptionPlanEdit />} />
            <Route path="plans/:id" element={<SubscriptionPlanEdit />} />
            <Route path="subscriptions" element={<SubscriptionsList />} />
            <Route path="subscriptions/:id" element={<SubscriptionDetailPage />} />
            <Route path="settings" element={<ProfileEdit />} />
            {/* Старые адреса раздела «Профили» — на настройки, чтобы закладки не ломались. */}
            <Route path="profiles" element={<Navigate to="/admin/settings" replace />} />
            <Route path="profiles/*" element={<Navigate to="/admin/settings" replace />} />
            <Route path="users" element={<UsersList />} />
            <Route path="users/new" element={<UserEdit />} />
            <Route path="users/:id" element={<UserEdit />} />
            <Route path="audit" element={<AuditLog />} />
          </Route>
          <Route path="*" element={<Navigate to="/admin" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  </React.StrictMode>,
);
